
(function() {
	/**
	 * Create pdf output
	 * requires jsPDF.js
	 *
	 * @author Øyvind
	 */	
	var pdfbtn = document.querySelector('.print-index-pdf');

	if ( pdfbtn )
		pdfbtn.addEventListener('click', bti_printhandler, false);
	
	function bti_printhandler( event ) {
		event.preventDefault();

		var title = document.querySelector('h1.modell-title');
		title = title ? title.innerText : 'BTI-rettleiar';

		var boxes = document.querySelectorAll('.flexEH article');

		// lets print
		var doc = new jsPDF({
			orientation: 'landscape',
			unit: 'mm',
			format: 'a4'
		});
		
		// font family
		doc.setFont('helvetica', 'normal');

		// bg
		doc.setFillColor(231, 247, 251);
		doc.rect(0, 0, 297, 210, 'F');

		// header
		doc.setFillColor(0, 48, 80);
		doc.rect(0, 12, 297, 23, 'F');

		// header text
		doc.setTextColor(255, 255, 255);
		doc.setFontSize(22);
		doc.customText(title, {align: 'center'},120, 26 );

		// frame
		doc.setFillColor(255, 255, 255);
		doc.rect(15, 48, 267, 150, 'F');

		// boxes
		var box,
			box_size = [20, 53, 62, 140, 'F'],
			box_padding = 3;
		doc.setTextColor(51, 51, 51);
		for( var i = 0; i < boxes.length; i++ ) {
			box = boxes[i];

			// extract rgb colors
			var colors = getComputedStyle(box).backgroundColor.slice(4,-1).split(', ');
			
			// increment x position
			box_size[0] = i === 0 ? box_size[0] : box_size[0] + 65;
			
			// draw the bg box
			doc.setFillColor( parseInt(colors[0]), parseInt(colors[1]), parseInt(colors[2]));
			doc.rect(box_size[0], box_size[1], box_size[2], box_size[3], box_size[4]);

			// title text
			var box_title = box.querySelector('h1');
			box_title = box_title ? box_title.innerText : 'Mangler tittel';
			doc.setFontSize(18);
			doc.text(box_title, box_size[0] + box_padding, box_size[1] + 10 );

			// box excerpt
			doc.setFontSize(10);
			doc.setFontStyle('normal');
			
			var box_excerpt = box.querySelector('p');
			box_excerpt = box_excerpt ? box_excerpt.innerText : 'Mangler utdrag';
			box_excerpt.replace('  ', ' ');

			// split long text
			var line_y = box_size[1] + 16,
				lines = dashify_lines(box_excerpt);

			for ( var l = 0; l < lines.length; l++ ) {
				doc.text(lines[l].trim(), box_size[0] + box_padding, line_y );
				line_y += 4.5;
			}

			// first step title y position
			var step_y = line_y > 92 ? line_y + 8 : 100;

			// steps
			var steps = box.querySelectorAll('ul li a'),
				s_txt;
			for ( var s = 0; s < steps.length; s++ ) {
				s_txt = steps[s].innerText.split(':');
				
				// step title
				doc.setFontStyle('bold');
				doc.text(s_txt[0] + ':', box_size[0] + box_padding, step_y );

				// step excerpt
				doc.setFontStyle('normal');
				// split lines
				step_y += 5;
				var all_lines = dashify_lines( s_txt[1] );
				for ( var sl = 0; sl < all_lines.length; sl++ ) {
					doc.text(all_lines[sl], box_size[0] + box_padding, step_y );
					step_y += 4.5;
				}

				step_y += 7;
			}
		}
		// Generate and save the pdf
		// doc.output('dataurlnewwindow');
		doc.save('BTI-oversikt-'+ Date.now() +'.pdf');
	}

	/**
	 * Add dash to end of line on broken words
	 */
	function dashify_lines( str ) {
		var pos = 0,
			i,
			two_char,
			line_length = 32,
			num_lines = str.length / line_length,
			line,
			lines = [];

		// dont split short string.
		if ( str.length < line_length + 3 ) {
			lines.push(str); 

			return lines;
		}

		// split string into array
		for ( i = 0; i < num_lines; i++ ) {
			line = str.substr(pos, line_length);
			lines.push(line);

			pos += line_length;
		}

		// dont break word after first char
		for ( i = 0; i < lines.length - 1; i++ ) {
			two_char = lines[i].slice(-2);
			// dont split word after first char
			if ( two_char.match(/\s\w/) && lines[i+1].slice(0,1).match(/\w/) ) {
				lines[i] = lines[i].slice(0,-2);
				lines[i+1] = two_char + lines[i+1];
			}
		}

		// dont break word with one char on next line
		for ( i = 1; i < lines.length; i++ ) {
			two_char = lines[i].slice(0,2);

			// dont split lines if there is only on more char or dot in word
			if ( two_char.match(/(\w(\.|,|\s)|(\.|,)\s)/) ) {
				lines[i] = lines[i].slice(2);
				lines[i-1] = lines[i-1] + two_char;
			}	
		}

		// add dash to broken words
		for ( i = 0; i < lines.length; i++ ) {

			// dont add dash on last line
			if ( i === lines.length - 1 )
				continue;


			if ( lines[i].slice(-1).match(/\w/) &&  lines[i+1].slice(0,1).match(/\w/) ) {
				lines[i] = lines[i] + '-';
			}
		}

		// trim withespace from lines
		for ( i = 0; i < lines.length; i++ ) {
			lines[i] = lines[i].trim();
			// delete empty indexes
			if ( lines[i] === "" )
				lines.splice(i, 1);
		}

		// return formatted lines
		return lines;
	}
})();
